// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormErrorStub__wrapper___1zB1q","error":"FormErrorStub__error___xWQ7H","buttons":"FormErrorStub__buttons___3k3SD"};